import SiteUtil from '@shared/utils/siteUtil.js'

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.prerender) {
    return
  }

  const userStore = useUserStore()
  const router = useRouter()
  if (to.meta.public) {
    return
  }

  if (!userStore.isAuthenticated) {
    console.log('Auth middleware: User not authenticated. Redirecting to login.')

    const candidate = to.fullPath !== '/' ? to.fullPath : undefined
    const redirectTo = SiteUtil.safeInternalRedirect(candidate)

    if (to.path !== '/login') {
      return navigateTo({
        path: '/login',
        query: {
          ...(redirectTo && { redirectTo }),
        },
      }, { replace: true })
    }
  }
  if (to.meta.roles && Array.isArray(to.meta.roles) && to.meta.roles.length > 0) {
    const userRole = userStore.profile?.role
    if (!userRole || !to.meta.roles.includes(userRole)) {
      console.log(`Auth middleware: User role '${userRole}' not authorized for route '${to.path}'.`)

      return navigateTo('/not-authorized', { replace: true })
    }
  }

  /*if (to.meta.acl && Array.isArray(to.meta.acl) && to.meta.acl.length > 0) {*/
  const userAcl = userStore.profile?.acl
  if (!userAcl) {
    const userRole = userStore.profile?.role
    console.log(`Auth middleware: User role '${userRole}' not authorized for route '${to.path}'.`)

    return navigateTo('/not-authorized', { replace: true })
  }
  if (userAcl === 'Company' && /my/gi.test(to.fullPath)) {
    console.log('Auth middleware: User role \'Company\' not authorized for route \'/my/...\'')

    return navigateTo('/business', { replace: true })

  }
  if (userAcl === 'Customer' && /business/gi.test(to.fullPath)) {
    console.log('Auth middleware: User role \'Customer\' not authorized for route \'/business/...\'')

    return navigateTo('/my', { replace: true })

  }

})
 
